<!--订单详情-->
<template>
  <div class="com-table order-details border">
    <div class="com-title pr">订单详情</div>
    <div class="order-contents clear">
      <ul class="fl">
        <li><label>订单单号：</label>{{data.orderCode}}</li>
        <li><label>市场价：</label>{{data.goodMinMarketPrice}} ~ {{data.goodMaxMarketPrice}} 元</li>
        <li><label>金额：</label>{{data.goodExchangeScore}} 积分</li>
        <!--<li><label>发货状态：</label>{{data.orderCode}}</li>
        <li><label>收货状态：</label>{{data.orderCode}}</li>-->
      </ul>
      <ul class="fl">
        <li><label>商品名称：</label>{{data.goodTitle}}</li>
        <li><label>消耗积分：</label>{{data.consumeScore}}</li>
        <li><label>状态：</label><span v-if="data.status === -1">交易已取消</span><span v-if="data.status === 1">待发货</span><span v-if="data.status === 2">待收货</span><span v-if="data.status === 3">交易成功</span></li>
        <!--<li><label>收货人：</label>{{data.orderCode}}</li>-->
      </ul>
      <ul class="fl">
        <li><label></label></li>
        <li><label>数量：</label>{{data.amount}}</li>
        <li><label>订单时间：</label>{{data.publishTime}}</li>
        <!--<li><label>联系电话：</label>{{data.orderCode}}</li>-->
      </ul>
    </div>
    <div class="com-title pr">物流信息</div>
    <template v-if="!express.isShow">
      <p class="log-info"><label>物流公司：</label><span>{{express.data.companyCode}}</span><label>物流单号：</label><span>{{express.data.code}}</span></p>
      <div class="real clear pr">
        <label class="pa">物流动态：</label>
        <ul class="fl">
          <li v-for="item in content"><span>{{item.time}}</span>{{item.context}}</li>
          <!--<li>2019-02-24 22:13:00【茂名市】顺丰速运 茂名电白工业园营业部收件员 已揽件</li>
          <li>2019-02-24 22:18:00【茂名市】茂名电白工业园营业部 已发出</li>
          <li>2019-02-24 22:51:00【茂名市】快件已到达 茂名高新集散点</li>
          <li>2019-02-24 23:14:00【茂名市】茂名高新集散点 已发出</li>
          <li>2019-02-25 06:18:00【广州市】快件已到达 广州新塘集散中心</li>
          <li>2019-02-25 08:11:00【广州市】广州新塘集散中心 已发出</li>
          <li>2019-02-25 09:00:00【广州市】快件已到达 广州天河长湴东路营业点</li>
          <li>2019-02-25 09:18:00【广州市】长湴东路营业站派件员：顺丰速运 95338正在为您派件</li>
          <li>2019-02-25 09:46:29您的快件已暂存至广州天鹅花苑A10栋吉市多便利店菜鸟驿站，请凭取货码及时领取。如有疑问请联系15812959499</li>
          <li>2019-02-25 23:28:06您已在广州天鹅花苑A10栋吉市多便利店完成取件，感谢使用菜鸟驿站，期待再次为您服务。</li>-->
        </ul>
      </div>
    </template>
    <no-data v-else></no-data>

  </div>
</template>
<script>
  import Api from '@/api/client/my-order'
  export default {
    created () {
      this.data = {}
      this.requestList()
    },
    data () {
      return {
        data: {},
        express: {
          data: {},
          isShow: true
        },
        content: []
      }
    },
    methods: {
      requestList () {
        let id = this.$route.params.id
        Api.getExpress(id, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status >= 200 && status <= 204) {
            this.data = body
            let express = body.express
            if (Object.keys(express).length > 0) {
              this.express.isShow = false
              this.express.data = express
              this.content = JSON.parse(body.express.content)
            } else {
              this.express.isShow = true
            }
          } else {
            this.express.data = {}
            this.content = []
          }
        })
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '../../assets/styles/env';
  .order-details{
    font-size:$font-secondary;
    color:$color-gray;
    label{
      display:inline-block;
      width:82px;
      text-align: right;
    }
    .order-contents{
      ul{
        display: inline-block;
        margin-right:80px;
        li{
          margin-bottom:50px;
          label{
            display:inline-block;
            width:82px;
            height:19px;
            text-align:right;
          }
        }
      }
    }
    .log-info{
      span{
        margin-right:126px;
      }
    }
    .real{
      padding-top: 20px;
      ul{
        margin-left:84px;
        li{
          margin-bottom:5px;
          span{margin-right:10px;}
        }
      }
    }
  }
</style>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/client/OrderDetails.vue